// removed by extract-text-webpack-plugin
module.exports = {"buttonGroup":"CategoryRadio__buttonGroup___6kZLc","radio":"CategoryRadio__radio___39ZNo","radioContainer":"CategoryRadio__radioContainer___1lC5h","iconContainer":"CategoryRadio__iconContainer___1TeOq","svg":"CategoryRadio__svg___3tzB2","textContainer":"CategoryRadio__textContainer___2BC4Y","categoryTitle":"CategoryRadio__categoryTitle___w_DpG","categoryDesc":"CategoryRadio__categoryDesc___1RJhZ","active":"CategoryRadio__active___XRBIw"};


//////////////////
// WEBPACK FOOTER
// ./src/routes/employer/project/components/CategoryRadio.scss
// module id = 1915
// module chunks = 0